import { Injectable, Injector } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../environments/environment';
import { AuthenticationService } from '../_services/authentication.service'
import { TranslateService } from '../_services/translate.service'
import { tap, catchError, map } from 'rxjs/operators';
import * as CryptoJS from 'crypto-js';

@Injectable()
export class BasicAuthInterceptor implements HttpInterceptor {
  public currrentLang: string = localStorage.getItem('language');
  constructor(private authenticationService: AuthenticationService,
    private translate: TranslateService) { }
  // intercept(request: HttpRequest < any > , next: HttpHandler): Observable < HttpEvent < any >> {
  //   const currentUserDetails = this.authenticationService.currentUserValue;
  //   const currentLang = this.translate.currentLanguageValue;
  //   console.log("xyz",currentLang)
  //   if (currentUserDetails && currentUserDetails.token) {
  //     request = request.clone({
  //       setHeaders: {
  //         Authorization: `Bearer ${currentUserDetails.token}`,
  //         language: currentLang.language
  //       }
  //     });
  //   } else {
  //     request = request.clone({
  //       setHeaders: {
  //         language: currentLang.language
  //       }
  //     });
  //   }
  //   return next.handle(request);
  // }


  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const isBinaryResponse = request.responseType === 'blob' || request.responseType === 'arraybuffer';
    const isFormDataBody = request.body instanceof FormData;

    // add authorization header with basic auth credentials if available
    if (!isBinaryResponse && !isFormDataBody && ((environment.encryption_mode == true && (request.body && request.body.encrypt_mode && request.body.encrypt_mode != false)) || (environment.encryption_mode == true && (request.body == null)) || (environment.encryption_mode == true && (request.body && request.body.encrypt_mode == null)))) {
      var iv = CryptoJS.lib.WordArray.random(16);
      let sendiv = CryptoJS.enc.Hex.stringify(iv)
      var keyBytes = CryptoJS.enc.Hex.parse(environment.enc_token);
      var ivBytes = CryptoJS.enc.Hex.parse(sendiv);

      var encrypt = CryptoJS.AES.encrypt(JSON.stringify(request.body), keyBytes, {
        iv: ivBytes,
        padding: CryptoJS.pad.ZeroPadding
      }).ciphertext.toString(CryptoJS.enc.Base64);

      // add authorization header with basic auth credentials if available
      const currentUser = this.authenticationService.currentUserValue;
      // const currentLang = this.translate.currentLanguageValue;

      // if (currentLang) {
      //   this.currrentLang = currentLang.language;
      // }
      if (currentUser && currentUser.token) {
        if (request.body) {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${currentUser.token}`,
              language: String(this.translate.currentLanguageValue.language)
            },
            body: { id: sendiv, document: encrypt }
          });
        } else {
          request = request.clone({
            setHeaders: {
              Authorization: `Bearer ${currentUser.token}`,
              language: String(this.translate.currentLanguageValue.language)
            }
          });
        }
      } else {

        if (request.body) {
          request = request.clone({
            setHeaders: {
              language: String(this.translate.currentLanguageValue.language)
            },
            body: { id: sendiv, document: encrypt }
          });
        } else {
          request = request.clone({
            setHeaders: {
              language: String(this.translate.currentLanguageValue.language)
            }
          });
        }
      }
      if ((request.url != 'assets/i18n/en.json') && (request.url != 'assets/i18n/fr.json')) {
        return next.handle(request).pipe(
          map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              const encryptedResponseBody = event.body as { id?: string; document?: string };

              if (encryptedResponseBody && encryptedResponseBody.id && encryptedResponseBody.document) {
                var keyBytes = CryptoJS.enc.Hex.parse(environment.enc_token);
                var ivBytes = CryptoJS.enc.Hex.parse(encryptedResponseBody.id);
                const decryptedWordArray = CryptoJS.AES.decrypt(encryptedResponseBody.document, keyBytes, {
                  iv: ivBytes,
                  padding: CryptoJS.pad.Pkcs7
                });
                let decrypt = this.hex2a(decryptedWordArray.toString().trim());
                decrypt = decodeURIComponent(escape(decrypt))

                if (event.body) {
                  event = event.clone({
                    body: JSON.parse(decrypt)
                  });
                }
              }
            }
            return event;
          }))
      } else {
        return next.handle(request);
      }
    } else {
      const currentUser = this.authenticationService.currentUserValue;
      const currentLang = this.translate.currentLanguageValue;
      // if (currentLang) {
      //   this.currrentLang = currentLang.language;
      // }

      if (currentUser && currentUser.token) {
        request = request.clone({
          setHeaders: {
            Authorization: `Bearer ${currentUser.token}`,
            language: String(this.translate.currentLanguageValue.language)
          }
        });
      } else {
        request = request.clone({
          setHeaders: {
            language: String(this.translate.currentLanguageValue.language)
          }
        });
      }
      return next.handle(request);
    }
  }

  hex2a(hex: string): string {
    var str = '';
    for (var i = 0; i < hex.length; i += 2)
      str += String.fromCharCode(parseInt(hex.substr(i, 2), 16));
    return str;
  }
}
